import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  sendNavigationEvent(linkUrl: string, linkText: string, navigationType: string = 'global_header') {
    gtag('event', 'navigation_click', {
      navigation_type: navigationType,
      link_url: linkUrl,
      link_text: linkText,
      page_location: window.location.href
    });
  }
}
